import type { Aktuell } from '@/payload-types'

export type AktuellCategory = Aktuell['category']

export const AKTUELL_CATEGORY_ORDER: AktuellCategory[] = [
  'insights',
  'wissen',
  'events',
  'aktionen',
]

export const AKTUELL_CATEGORY_LABEL: Record<AktuellCategory, string> = {
  insights: 'Insights',
  wissen: 'Wissen',
  events: 'Events',
  aktionen: 'Aktionen',
}
